import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import IconPlayButton from "./play-button.svg";

type ContainerProps = {
  $backgroundImage?: string;
  $orientation?: "landscape" | "portrait";
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-flow: column;
  row-gap: 10px;
  justify-content: center;
  align-items: center;

  inline-size: auto;
  block-size: 100%;

  background-image: url(${props => props.$backgroundImage});
  background-position: center;
  background-size: cover;

  cursor: pointer;

  aspect-ratio: ${props => (props.$orientation === "portrait" ? "9/16" : "16/9")};

  ${theme.breakpoints.up("tablet")} {
    row-gap: 16px;
  }
`;

export const Backdrop = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;

  inline-size: 100%;
  block-size: 100%;

  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
`;

export const PlayButton = styled(IconPlayButton)`
  inline-size: 50px;
  block-size: 50px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 100px;
    block-size: 100px;
  }
`;

export const Duration = styled.div`
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;

  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
  }
`;
